import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { CustoCalculado } from '../types/CustoCalculado.type';
import { DespesaFluxoCaixa } from '../types/DespesaFluxoCaixa.type';
import { ReceitaFluxoCaixa } from '../types/ReceitaFluxoCaixa.type';
import { Page } from '../types/Page.type';

@Injectable({
  providedIn: 'root'
})
export class FluxocaixaService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  // Fluxo de Caixa - Despesas
  getDespesasFluxoCaixa(page: number, size: number, sortField: string, sortDirection: string, instancia: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<Page<DespesaFluxoCaixa>>(`${this.configService.getApiUrlRoot()}/fluxocaixa/despesas`,
      { params: this.montarParametros(page, size, sortField, sortDirection, instancia, dataInicio, dataFim) });
  }

  // Fluxo de Caixa - Receitas
  getReceitasFluxoCaixa(page: number, size: number, sortField: string, sortDirection: string, instancia: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<Page<ReceitaFluxoCaixa>>(`${this.configService.getApiUrlRoot()}/fluxocaixa/receitas`,
      { params: this.montarParametros(page, size, sortField, sortDirection, instancia, dataInicio, dataFim) });
  }

  // Fluxo de Caixa - Custos Calculados
  getCustosCalculados(page: number, size: number, sortField: string, sortDirection: string, instancia: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<Page<CustoCalculado>>(`${this.configService.getApiUrlRoot()}/custoscalculados/`,
      { params: this.montarParametros(page, size, sortField, sortDirection, instancia, dataInicio, dataFim) });
  }

  // O backend (Pageable + Specification) espera "instancia", "dataInicio", "dataFim" e "sort=campo,direcao".
  // A instância é traduzida para empresa/filial pelo próprio serviço.
  private montarParametros(page: number, size: number, sortField: string, sortDirection: string, instancia: string, dataInicio: string, dataFim: string){
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (sortField) {
      params = params.set('sort', `${sortField},${sortDirection || 'asc'}`);
    }

    if (instancia) {
      params = params.set('instancia', instancia);
    }

    if (dataInicio) {
      params = params.set('dataInicio', dataInicio);
    }

    if (dataFim) {
      params = params.set('dataFim', dataFim);
    }

    return params;
  }

  exportarDespesas(corpo: any){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/fluxocaixa/despesas/relatorios/exportar`, { responseType: 'blob'});
  }

  exportarReceitas(corpo: any){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/fluxocaixa/receitas/relatorios/exportar`, { responseType: 'blob'});
  }

  exportarCustosCalculados(corpo: any){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/custoscalculados/relatorios/exportar`, { responseType: 'blob'});
  }
}
